









import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({
  components: {

  },
})
export default class TypeItem extends Vue {
  @Prop({default: false})
  private child!: boolean;

  @Prop({default: false})
  private active!: boolean;

  @Prop({default: ''})
  private title!: string;

  @Prop({default: ''})
  private id!: string;

  @Prop({default: ''})
  private img?: string;

  private handleClick() {
    this.$emit('selected', this.id)
  }
}
